angular.module('unica_media_moderation.media_controllers')

.controller('MediaModerationListController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm, $uibModal, Lightbox,
	MediaModerationListService, MediaModerationDeleteService, MediaModerationEditService
) {

	$scope.mediaList = [];
	$scope.limit  = 11;
	$scope.offset = 0;
	$scope.canLoad = false;
	$scope.event_id = $stateParams.event_id;
	$scope.showDeclined = false;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.tiles = [];

	$scope.toggleShowDeclined = function() {
		$scope.showDeclined = !$scope.showDeclined;

		$scope.limit  = 11;
		$scope.offset = 0;
		$scope.mediaList = [];
		$scope.tiles = [];
		this.loadMedia();

	};

	$scope.loadMedia = function() {
		$scope.showLoader();
		$scope.canLoad = false;

		MediaModerationListService
			.list( $stateParams.event_id, $scope.limit, $scope.offset, $scope.showDeclined ? 'declined' : 'pending' )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.mediaList = $scope.mediaList.concat( data );

					$scope.tiles = $scope.tiles.concat( buildGridModel(data, {
						id: '', image : '', title: '', status: ''
					}) );

					if ( data.length < $scope.limit ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				} else {
						$scope.canLoad = false;
				}
			});
	};

	$scope.loadMedia();

	$scope.openLightboxModal = function (index) {
		Lightbox.openModal($scope.mediaList, index);
	};

	$rootScope.$on( 'media_deleted', function(event, data) {

	});

	function buildGridModel(medias, tileTmpl) {
		var it,
			results = [ ],
			j = 0;

		angular.forEach(medias, function(md) {

			it = angular.extend({}, tileTmpl);
			it.inv_id  		= md.invitation_id;
			it.field_id     = md.field_id;
			it.user_id      = md.user_id;
			it.image   		= md.url;
			it.title  		= md.label;
			it.type    		= ( md.type ? md.type : 'other');
			it.status  		= md.status;
			it.span    		= { row : 1, col : 1 };

			if ( j == 11 ) {
				j = 0;
			}

			switch ( j+1 ) {
				case 1:
					it.span.row = it.span.col = 2;
					break;
				case 4:
					it.span.col = 2;
					break;

				case 5:
					it.span.row = it.span.col = 2;
					break;
			}

			j++;

			results.push(it);
		});

		return results;
	}


	$scope.approveMedia = function( invitationId, fieldId )
	{
		var media = null;
		angular.forEach($scope.mediaList, function(m, key) {
			if ( m.invitation_id === invitationId && m.field_id === fieldId ) {
				media = m;
			}
		});

		$scope.showLoader();

		MediaModerationEditService
			.approveMedia( media.invitation_id, media.field_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					angular.forEach($scope.mediaList, function(m, key) {
						if ( m.invitation_id === invitationId && m.field_id === fieldId ) {
							$scope.mediaList.splice(key, 1);
						}
					});

					angular.forEach($scope.tiles, function(tile, key) {
						if ( tile.inv_id === invitationId && tile.field_id === fieldId ) {
							$scope.tiles.splice(key, 1);
						}
					});

					$scope.showSuccessMsg('Media aggiornato con successo!', '');
				}
			});
	};


	$scope.declineMedia = function( invitationId, fieldId )
	{
		var media = null;
		angular.forEach($scope.mediaList, function(m, key) {
			if ( m.invitation_id === invitationId && m.field_id === fieldId ) {
				media = m;
			}
		});

		$scope.showLoader();

		MediaModerationEditService
			.declineMedia( media.invitation_id, media.field_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					angular.forEach($scope.mediaList, function(m, key) {
						if ( m.invitation_id === invitationId && m.field_id === fieldId ) {
							$scope.mediaList.splice(key, 1);
						}
					});

					angular.forEach($scope.tiles, function(tile, key) {
						if ( tile.inv_id === invitationId && tile.field_id === fieldId ) {
							$scope.tiles.splice(key, 1);
						}
					});

					$scope.showSuccessMsg('Media aggiornato con successo!', '');
				}
			});
	};


	$scope.restoreMedia = function( invitationId, fieldId )
	{
		var media = null;
		angular.forEach($scope.mediaList, function(m, key) {
			if ( m.invitation_id === invitationId && m.field_id === fieldId ) {
				media = m;
			}
		});

		$scope.showLoader();

		MediaModerationEditService
			.restoreMedia( media.invitation_id, media.field_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					angular.forEach($scope.mediaList, function(m, key) {
						if ( m.invitation_id === invitationId && m.field_id === fieldId ) {
							$scope.mediaList.splice(key, 1);
						}
					});

					angular.forEach($scope.tiles, function(tile, key) {
						if ( tile.inv_id === invitationId && tile.field_id === fieldId ) {
							$scope.tiles.splice(key, 1);
						}
					});

					$scope.showSuccessMsg('Media aggiornato con successo!', '');
				}
			});
	};

	// $scope.showDelete = true;
	// if ( sessionStorage.getItem('sub_from_admin_archive') ) {
	// 	sessionStorage.removeItem('sub_from_admin_archive');
	// 	$scope.showDelete = false;
	// }

})

.controller('LightboxController', function ($rootScope, $scope, Lightbox) {

});